/* eslint-disable no-nested-ternary */
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCardProjectStyle } from '../selectors';
import { UPDATE_VIEW_COUNT_BY_PROJECTS } from '../slice';
import { ProjectItemWrapper } from '../styled';
import { I_Project } from '../types';
import { I_CollectionPortfolio } from '../typesIndex';

interface Props {
  project: I_Project;
  viewCountByProjects: I_CollectionPortfolio['viewCountByProjects'];
  collectionPortfolioIdSelected: I_CollectionPortfolio['id'];
}

const ProjectItem = memo(
  ({ project, viewCountByProjects, collectionPortfolioIdSelected }: Props) => {
    const dispatch = useDispatch();
    const cardProjectStyle = useSelector(selectCardProjectStyle);

    const onOpenLinkProject = (id: string, slug: string) => {
      dispatch(
        UPDATE_VIEW_COUNT_BY_PROJECTS({
          project: id,
          id: collectionPortfolioIdSelected,
        }),
      );
      window.open(
        `${process.env.NEXT_PUBLIC_BASE_URL_PUBLIC}/${slug}`,
        '_blank',
      );
    };

    return (
      <ProjectItemWrapper
        key={project.id}
        className={`projectStyle-${cardProjectStyle}`}
        onClick={() => onOpenLinkProject(project.id, project.slug)}
      >
        <div className="--pjInfo">
          <h3 className="--pjTitle">{project?.title}</h3>
          <div className="--pjShortDesc">
            {project.subTitle ||
              project.config?.marketing?.meta_data?.description ||
              ''}
          </div>
          <div className="--pjStats">
            <ul className="d-flex">
              <li>
                <i aria-hidden className="far fa-image" />
                {project.scenes_count || 0}
              </li>
              <li>
                <i aria-hidden className="far fa-eye" />
                {viewCountByProjects
                  ? viewCountByProjects[project.id]?.count || 0
                  : 0}
              </li>
            </ul>
          </div>
        </div>
        <div className="--pjImg">
          <img
            src={
              project?.thumbnail
                ? project?.thumbnail?.src_thumb ||
                  project?.thumbnail?.src_preview ||
                  project?.thumbnail?.src
                : project.featured_image
                ? project?.featured_image
                : project?.first_scene && project.first_scene?.media
                ? project.first_scene?.media?.src_thumb ||
                  project.first_scene?.media?.src_preview ||
                  ''
                : ''
            }
            alt={project?.title || ''}
            title={project?.title || ''}
          />
        </div>
      </ProjectItemWrapper>
    );
  },
);

export default ProjectItem;
